import React from 'react'

import Books from '../components/Books'
import Layout from '../components/Layout'
import PageHeader from '../components/PageHeader'
import SEO from '../components/SEO'
import Box from '../styled/Box'

const Bookshelf = () => {
  return (
    <Layout maxContentWidth={{ _: '56.25rem', xl: '75rem' }}>
      <SEO title="Bookshelf" />
      <PageHeader title="Bookshelf" />
      <Books />
    </Layout>
  )
}

export default Bookshelf
